import type { ActionType } from "./character/character"

/** Server-authoritative animation playback for any entity, independent of attacks and input. */
export interface AnimationPoseView {
    id: string
    action: ActionType | string
    angle: number
    durationMs: number
    remainingMs: number
    /** Zero-based frame to raise to, then hold indefinitely until replaced or cleared. */
    holdFrame?: number
    /**
     * A performance (ember_sprite/animations.ts): `action` names one, played in the body's facing,
     * and when it has played the body goes back to whatever it was doing.
     */
    performance?: boolean
    /** Plays over and over until replaced or cleared: progress wraps instead of ending. */
    loop?: boolean
}

/** Holding never advances into a release on its own, including after a late snapshot. */
export const sampleAnimationPose = (view: AnimationPoseView, elapsedMs: number) => {
    if (view.loop && view.durationMs > 0) {
        const played = view.durationMs - view.remainingMs + Math.max(0, elapsedMs)
        return { action: view.action, progress: (((played % view.durationMs) + view.durationMs) % view.durationMs) / view.durationMs }
    }
    const remaining = view.remainingMs - Math.max(0, elapsedMs)
    const progress = view.durationMs > 0 ? Math.max(0, Math.min(1, 1 - remaining / view.durationMs)) : 1
    if (view.holdFrame !== undefined) return {
        action: view.action, progress: 0, frame: Math.floor(progress * view.holdFrame),
    }
    return { action: remaining <= 0 ? "idle" as const : view.action, progress }
}
